import { css } from 'styled-components';

export const SharedListStyle = css`
  padding-inline-start: 27px;
  position: relative;
  ul {
    margin-top: 0.5em;
    padding-inline-start: 20px;
  }
  li {
    padding-left: 3px;
  }

  ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    padding-inline-start: 20px;
    unicode-bidi: isolate;
  }
`;

export const SharedCustomBulletPointStyle = css``;
